import * as types from '../actionType'

const initialState = []

const userEditAddress = (state = initialState, action) => {
    switch (action.type) {
        case types.USER_EDIT_ADDRESS:
            return action.payload
        default:
            return state
    }
}


export { userEditAddress }